import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityLog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 31,
	viewBox: "0 0 36 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.3971 1.38289L17.3977 1.38354L19.8915 3.94854L20.0388 4.1H20.25H32.5C33.3241 4.1 34.02 4.39572 34.6142 5.00694C35.2089 5.61856 35.501 6.34029 35.5 7.19941V7.2V23.4C35.5 24.261 35.2075 24.9836 34.614 25.5952C34.0213 26.2058 33.3258 26.501 32.5006 26.5H32.5H8C7.17567 26.5 6.48039 26.2047 5.8875 25.5949C5.29423 24.9846 5.00108 24.2621 5 23.3997V3.6C5 2.73931 5.29282 2.01757 5.8872 1.40724C6.48157 0.796933 7.17722 0.501099 8.00032 0.5H15.3062C15.7067 0.5 16.0852 0.576829 16.4459 0.730161C16.808 0.884077 17.124 1.10094 17.3971 1.38289Z",
		fill: "currentColor",
		stroke: "#2C2A43"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9126 5.81192L12.9132 5.81254L15.407 8.16379L15.5515 8.3H15.75H28C28.8379 8.3 29.5387 8.57668 30.1297 9.13399C30.7199 9.69045 31.001 10.337 31 11.0994V11.1V25.95C31 26.7142 30.7185 27.3616 30.1294 27.9179C29.5399 28.4747 28.8396 28.751 28.0006 28.75H28H3.5C2.66182 28.75 1.96175 28.4737 1.37201 27.9177C0.783238 27.3625 0.50106 26.7152 0.5 25.9497V7.8C0.5 7.03617 0.781769 6.38956 1.3717 5.83429C1.96294 5.27777 2.66337 5.00102 3.50029 5H10.8062C11.2125 5 11.5959 5.07154 11.96 5.21339C12.3253 5.35573 12.6414 5.55527 12.9126 5.81192Z",
		fill: "currentColor",
		stroke: "#2C2A43"
	})]
});
export default SvgActivityLog;
